export default "__VITE_ASSET__Cz67gQSe__"